// signup.js
import React, { useState } from "react";
import "./login.css";
import { useAuth } from "../contexts/authContext";

const SignUpModal = ({ isOpen, onClose }) => {
  const { signup, loading, authError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [codFiscal, setCodFiscal] = useState("");
  const [denumire, setDenumire] = useState("");
  const [adresa, setAdresa] = useState("");
  const [judet, setJudet] = useState("");
  const [localitate, setLocalitate] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await signup({
      email,
      password,
      codFiscal,
      denumire,
      adresa,
      judet,
      localitate,
    });
    if (res.success) {
      setSuccessMessage(
        "Cont creat cu succes! Te rugăm să verifici adresa de email pentru a activa contul."
      );
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Sign up</h2>
        {successMessage ? (
          <div className="success-panel">
            <h3>✔ Cont creat</h3>
            <p>{successMessage}</p>
            <button
              className="login-btn"
              onClick={() => {
                setSuccessMessage("");
                onClose();
              }}
            >
              Am înțeles
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="inputs-container">
            <div className="input-group">
              <span className="input-label">Denumire firmă</span>
              <input
                type="text"
                className="modern-input"
                placeholder="Ex: Alza Test SRL"
                value={denumire}
                onChange={(e) => setDenumire(e.target.value)}
              />
            </div>

            <div className="input-group">
              <span className="input-label">Email</span>
              <input
                type="email"
                className="modern-input"
                placeholder="user@firma.ro"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <span className="input-label">Parolă</span>
              <input
                type="password"
                className="modern-input"
                placeholder="Parola"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <span className="input-label">Cod fiscal</span>
              <input
                type="text"
                className="modern-input"
                placeholder="Cod fiscal"
                value={codFiscal}
                onChange={(e) => setCodFiscal(e.target.value)}
                required
              />
            </div>

            {authError && (
              <p style={{ color: "#fca5a5", fontSize: "0.8rem", marginTop: 2 }}>
                {authError}
              </p>
            )}

            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? "Se creează contul..." : "Creează cont"}
            </button>
          </form>
        )}
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>
      </div>
    </div>
  );
};

export default SignUpModal;
